import { V360ReportData } from "view360Card/models";
import { V360ReportDataDto } from "view360Card/service/dtos/V360ReportDataDto";

export class MonthlyReportDataFromResponse {
    constructor(private dto: V360ReportDataDto) {}

    toDomainModel(): V360ReportData {
        return {
            code: this.dto.report.code,
            name: this.dto.report.name,
            labels: this.dto.report.labels ?? [],
            seriesList: (this.dto.report.seriesList ?? []).map((s) => {
                return {
                    code: s.code ?? "",
                    dataset: s.dataset ?? [],
                    name: s.name ?? "",
                    tooltip: s.tooltip ?? "",
                    unitType: s.unitType ?? "",
                    year: s.year ?? 0,
                    orderIndex: s.orderIndex,
                };
            }),
        };
    }
}
